import styled from 'styled-components';
import React from 'react';

import colors from 'shared-assets/lib/colors';
import PropTypes from 'prop-types';
import styles from 'shared-assets/lib/styles';

import hexToRgb from 'pretty-easy-hex-to-rgb';
import { lighten } from 'polished';

const RadioInput = styled.input`
  opacity: 0;
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 0;
  margin: 0;
  height: 1rem;
  width: 1rem;

  & ~ span {
    height: 1rem;
    width: 1rem;
    background-color: #fff;
    border: ${styles.border.default};
    border-radius: 50%;

    &::after {
      align-self: center;
      content: '';
      width: 0.625rem;
      height: 0.625rem;
      border-radius: 50%;
    }
  }

  &:hover:not(:checked) ~ span {
    background-color: rgba(
      ${hexToRgb(lighten(0.1, colors.primary)).join(', ')},
      0.08
    );
  }

  &:checked ~ span {
    border-color: rgb(${hexToRgb(lighten(0.15, colors.primary)).join(', ')});
    display: flex;
    justify-content: center;

    &::after {
      background-color: rgb(
        ${hexToRgb(lighten(0.15, colors.primary)).join(', ')}
      );
    }
  }

  &:disabled ~ span {
    background: rgba(${colors.secondaryRGB.join(', ')}, 0.08);
    border-color: rgba(${colors.secondaryRGB.join(', ')}, 0.2);
  }

  &:checked:disabled ~ span {
    background: #fff;
    border-color: rgba(
      ${hexToRgb(lighten(0.1, colors.primary)).join(', ')},
      0.5
    );

    &::after {
      background-color: rgba(
        ${hexToRgb(lighten(0.1, colors.primary)).join(', ')},
        0.5
      );
    }
  }
`;

RadioInput.defaultProps = {
  type: 'radio',
  checked: undefined,
};

RadioInput.propTypes = {
  type: PropTypes.string,
  checked: PropTypes.any,
};

const RadioContainer = styled.span`
  display: flex;
  position: relative;
  align-items: center;
  cursor: pointer;
  font-size: 1rem;
  user-select: none;
  width: 1rem;
  height: 1rem;
`;

const Radio = props => (
  <RadioContainer>
    <RadioInput {...props} />
    <span />
  </RadioContainer>
);

Radio.defaultProps = {
  defaultValue: undefined,
  value: undefined,
  name: '',
  type: 'radio',
};

Radio.propTypes = {
  defaultValue: PropTypes.string,
  value: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.oneOf(['radio']),
};

export default Radio;
